import {ChangeDetectionStrategy, Component} from "@angular/core";
import {NavigationService} from "~/app/core/navigation.service";
import {BasePage} from "~/app/pages/base.page";

@Component({
    selector: "TermsOfUse",
    templateUrl: "./terms-of-use.page.html",
    styleUrls: ["./terms-of-use.page.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TermsOfUsePage extends BasePage {
    htmlSrc: string;

    constructor(
        private readonly nav: NavigationService,
    ) {
        super();
    }
}
